(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brs-stoq-inline"] && !Shopify.designMode) return;
  try {
    (() => {
    const buttonSelector = '.restock-rocket-button-product';
    const slotSelector = '.brs-stoq-slot';
    const emailSelector = '#form-Email';
    const initializedEmailFields = new WeakSet();
    let emailDraft = '';
    let queued = false;
    let observedButton;
    let observedForm;
    const resizeObserver = new ResizeObserver(queuePlacement);

    function placeButton() {
      queued = false;
      const slot = document.querySelector(slotSelector);
      updateEmailPrompt(slot);
      const button = document.querySelector(buttonSelector);
      if (!slot || !button) return;

      const wrapper = button.parentElement;
      if (!wrapper.classList.contains('restock-rocket-button-container-float-right')) return;
      wrapper.classList.add('brs-stoq-inline');
      if (wrapper.parentElement !== slot) slot.appendChild(wrapper);

      const form = slot.closest('form');
      const purchaseButton = form && form.querySelector('.button--single-cart-main');
      if (!purchaseButton) return;

      if (purchaseButton !== observedButton || form !== observedForm) {
        resizeObserver.disconnect();
        resizeObserver.observe(purchaseButton);
        resizeObserver.observe(form);
        observedButton = purchaseButton;
        observedForm = form;
      }

      const buttonRect = purchaseButton.getBoundingClientRect();
      const formRect = form.getBoundingClientRect();
      const offsets = {
        '--brs-stoq-left': Math.max(0, buttonRect.left - formRect.left),
        '--brs-stoq-right': Math.max(0, formRect.right - buttonRect.right)
      };
      Object.entries(offsets).forEach(([property, value]) => {
        const pixels = `${value.toFixed(2)}px`;
        if (slot.style.getPropertyValue(property) !== pixels) {
          slot.style.setProperty(property, pixels);
        }
      });
    }

    function queuePlacement() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(placeButton);
    }

    function updateEmailPrompt(slot) {
      const email = document.querySelector(emailSelector);
      if (!slot || !email) return;
      // Start a newly created signup field blank. Subsequent layout or option
      // updates must never erase what the customer is currently typing.
      if (!initializedEmailFields.has(email)) {
        initializedEmailFields.add(email);
        email.autocomplete = 'off';
        email.value = emailDraft;
        email.dispatchEvent(new Event('input', { bubbles: true }));
        email.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (email.placeholder !== slot.dataset.emailPlaceholder) {
        email.placeholder = slot.dataset.emailPlaceholder;
      }
      const label = email.labels && email.labels[0];
      if (label) {
        if (label.textContent !== slot.dataset.emailLabel) {
          label.textContent = slot.dataset.emailLabel;
        }
        label.classList.remove('sr-only');
        label.classList.add('brs-stoq-email-label');
      }
    }

    function start() {
      // Keep a draft only in this page's memory. STOQ rebuilds the field when
      // an option changes, so carry the customer's current text into that node.
      document.addEventListener('input', event => {
        if (event.target instanceof HTMLInputElement && event.target.matches(emailSelector)) {
          emailDraft = event.target.value;
        }
      }, true);
      queuePlacement();
      // STOQ may recreate its button after a size change. Move the original
      // node, preserving its handlers and its own visibility rules.
      new MutationObserver(records => {
        const relevant = records.some(record => [...record.addedNodes].some(node =>
          node.nodeType === 1 && (
            node.matches(`${buttonSelector}, ${slotSelector}, ${emailSelector}`) ||
            node.querySelector(`${buttonSelector}, ${slotSelector}, ${emailSelector}`)
          )
        ));
        if (relevant) queuePlacement();
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
